import authService from './auth-service/authService';
import shopService from './shop-service/shopService';

export default {
  authService,
  shopService,
};
